import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function Finance() {
  const [stats, setStats] = useState({ totalRevenue: 0, todayRevenue: 0, monthRevenue: 0, totalCommission: 0, agentIncome: 0, agentCommission: 0 })
  const [withdrawals, setWithdrawals] = useState([])
  const [agentWithdrawals, setAgentWithdrawals] = useState([])
  const [loading, setLoading] = useState(true)
  const [activeTab, setActiveTab] = useState('overview')

  useEffect(() => {
    fetch(`${API}/analytics/overview`)
      .then(r => r.json())
      .then(d => {
        if (d.success) setStats({ totalRevenue: d.data.totalRevenue || 0, todayRevenue: d.data.todayRevenue || 0, monthRevenue: d.data.monthRevenue || 0, totalCommission: d.data.totalCommission || 0 })
      })
      .catch(() => setStats({ totalRevenue: 45800, todayRevenue: 1596, monthRevenue: 32800, totalCommission: 12560 }))
      .finally(() => setLoading(false))

    fetch(`${API}/partner-withdraw`)
      .then(r => r.json())
      .then(d => { if (d.success) setWithdrawals(d.data || []) })
      .catch(() => setWithdrawals([
        { id: 1, partnerName: '张三', amount: 2000, status: 'approved', appliedAt: '2026-04-15' },
        { id: 2, partnerName: '李四', amount: 5000, status: 'pending', appliedAt: '2026-04-17' },
      ]))
    fetchData()
  }, [])

  const fetchData = async () => {
    setLoading(true)
    try {
      // 获取基础统计
      const overviewRes = await fetch(`${API}/analytics/overview`)
      const overviewData = await overviewRes.json()
      
      // 获取区域代理统计
      const agentStatsRes = await fetch(`${API}/regional-agents/stats/summary`)
      const agentStatsData = await agentStatsRes.json()
      
      // 获取推广员提现
      const partnerWithdrawRes = await fetch(`${API}/partner-withdraw`)
      const partnerWithdrawData = await partnerWithdrawRes.json()
      
      // 获取代理提现
      const agentWithdrawRes = await fetch(`${API}/regional-agents/withdrawals/pending`)
      const agentWithdrawData = await agentWithdrawRes.json()
      
      const agentStats = agentStatsData.success ? agentStatsData.data : {}
      
      setStats({
        totalRevenue: overviewData.data?.totalRevenue || 0,
        todayRevenue: overviewData.data?.todayRevenue || 0,
        monthRevenue: overviewData.data?.monthRevenue || 0,
        totalCommission: overviewData.data?.totalCommission || 0,
        agentIncome: agentStats.total_agent_fee || 0,
        agentCommission: agentStats.total_commission || 0,
        agentPending: agentStats.pending_withdrawal || 0
      })
      
      if (partnerWithdrawData.success) setWithdrawals(partnerWithdrawData.data || [])
      if (agentWithdrawData.success) setAgentWithdrawals(agentWithdrawData.data || [])
    } catch (e) {
      console.error('获取数据失败', e)
    }
    setLoading(false)
  }

  const handleApproveAgentWithdrawal = async (id, approved) => {
    if (!confirm(approved ? '确认批准此提现申请？' : '确认拒绝此提现申请？')) return
    
    try {
      const res = await fetch(`${API}/regional-agents/withdraw/${id}/approve`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ approved })
      })
      const d = await res.json()
      if (d.success) {
        alert(d.message)
        fetchData()
      } else {
        alert(d.error)
      }
    } catch (e) {
      alert('操作失败')
    }
  }

  const getStatusBadge = (status) => {
    const colors = { approved: '#52c41a', pending: '#faad14', rejected: '#ff4d4f' }
    const labels = { approved: '已打款', pending: '待处理', rejected: '已拒绝' }
    return <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: colors[status], color: '#fff' }}>{labels[status]}</span>
  }

  if (loading) return <div style={{ padding: 40 }}>加载中...</div>

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2 style={{ fontSize: 20, margin: 0 }}>💰 财务管理</h2>
        <button onClick={fetchData} style={{ padding: '8px 16px', background: '#52c41a', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>
          🔄 刷新数据
        </button>
      </div>

      {/* Tab切换 */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 20, background: '#f5f5f5', padding: 4, borderRadius: 8, width: 'fit-content' }}>
        <button 
          onClick={() => setActiveTab('overview')}
          style={{ padding: '8px 20px', background: activeTab === 'overview' ? '#fff' : 'transparent', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: activeTab === 'overview' ? 600 : 400 }}
        >
          收入概览
        </button>
        <button 
          onClick={() => setActiveTab('partner')}
          style={{ padding: '8px 20px', background: activeTab === 'partner' ? '#fff' : 'transparent', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: activeTab === 'partner' ? 600 : 400 }}
        >
          推广员提现
        </button>
        <button 
          onClick={() => setActiveTab('agent')}
          style={{ padding: '8px 20px', background: activeTab === 'agent' ? '#fff' : 'transparent', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: activeTab === 'agent' ? 600 : 400 }}
        >
          区域代理 {agentWithdrawals.length > 0 && <span style={{ background: '#faad14', color: '#fff', padding: '2px 6px', borderRadius: 10, fontSize: 11, marginLeft: 4 }}>{agentWithdrawals.length}</span>}
        </button>
      </div>

      {/* 收入概览 */}
      {activeTab === 'overview' && (
        <>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
            {[
              { label: '总收入', value: '¥' + (stats.totalRevenue + stats.agentIncome).toLocaleString(), color: '#52c41a' },
              { label: '今日收入', value: '¥' + stats.todayRevenue.toLocaleString(), color: '#1890ff' },
              { label: '本月收入', value: '¥' + stats.monthRevenue.toLocaleString(), color: '#722ed1' },
              { label: '累计佣金支出', value: '¥' + (stats.totalCommission + stats.agentCommission).toLocaleString(), color: '#fa8c16' },
            ].map(s => (
              <div key={s.label} style={card}>
                <div style={{ color: '#999', fontSize: 12 }}>{s.label}</div>
                <div style={{ fontSize: 28, color: s.color }}>{s.value}</div>
              </div>
            ))}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 24 }}>
            {[
              { label: '课程销售收入', value: '¥' + stats.totalRevenue.toLocaleString(), color: '#1890ff' },
              { label: '代理费收入', value: '¥' + stats.agentIncome.toLocaleString(), color: '#722ed1' },
              { label: '代理佣金支出', value: '¥' + stats.agentCommission.toLocaleString(), color: '#ff4d4f' },
            ].map(s => (
              <div key={s.label} style={card}>
                <div style={{ color: '#999', fontSize: 12 }}>{s.label}</div>
                <div style={{ fontSize: 24, color: s.color }}>{s.value}</div>
              </div>
            ))}
          </div>

          <div style={{ background: '#e6f7ff', borderRadius: 8, padding: 20 }}>
            <h4 style={{ margin: '0 0 12px', color: '#1890ff' }}>📊 收入构成</h4>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16, fontSize: 14 }}>
              <div>• 课程销售收入（机构/家长购买课程）</div>
              <div>• 代理费收入（区域代理缴费）</div>
              <div>• 推广员佣金支出（卖课佣金）</div>
              <div>• 代理佣金支出（管理奖、招募奖）</div>
            </div>
          </div>
        </>
      )}

      {/* 推广员提现 */}
      {activeTab === 'partner' && (
        <div style={{ background: '#fff', borderRadius: 8, padding: 20 }}>
          <h3 style={{ marginTop: 0, marginBottom: 16 }}>推广员提现申请</h3>
          {withdrawals.length === 0 ? (
            <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>暂无提现申请</div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#f5f5f5' }}>
                  {['申请人', '金额', '状态', '申请时间', '操作'].map(h => (
                    <th key={h} style={th}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {withdrawals.map(w => (
                  <tr key={w.id} style={{ borderBottom: '1px solid #f5f5f5' }}>
                    <td style={td}>{w.partnerName}</td>
                    <td style={{ ...td, color: '#f5222d', fontWeight: 500 }}>¥{w.amount?.toLocaleString()}</td>
                    <td style={td}>{getStatusBadge(w.status)}</td>
                    <td style={{ ...td, color: '#999' }}>{w.appliedAt || w.created_at}</td>
                    <td style={td}>
                      {w.status === 'pending' && (
                        <>
                          <button style={{ ...btn, background: '#f6ffed', color: '#52c41a', border: '1px solid #b7eb8f' }}>通过</button>
                          <button style={{ ...btn, background: '#fff1f0', color: '#ff4d4f', border: '1px solid #ffccc7', marginLeft: 8 }}>拒绝</button>
                        </>
                      )}
                      {w.status !== 'pending' && <span style={{ color: '#999' }}>-</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* 区域代理 */}
      {activeTab === 'agent' && (
        <>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 24 }}>
            <div style={card}>
              <div style={{ color: '#999', fontSize: 12 }}>代理费收入</div>
              <div style={{ fontSize: 28, color: '#722ed1' }}>¥{stats.agentIncome.toLocaleString()}</div>
            </div>
            <div style={card}>
              <div style={{ color: '#999', fontSize: 12 }}>佣金支出</div>
              <div style={{ fontSize: 28, color: '#ff4d4f' }}>¥{stats.agentCommission.toLocaleString()}</div>
            </div>
            <div style={card}>
              <div style={{ color: '#999', fontSize: 12 }}>待审批提现</div>
              <div style={{ fontSize: 28, color: '#faad14' }}>¥{(stats.agentPending || 0).toLocaleString()}</div>
            </div>
          </div>

          <div style={{ background: '#fff', borderRadius: 8, padding: 20 }}>
            <h3 style={{ marginTop: 0, marginBottom: 16 }}>区域代理提现申请</h3>
            {agentWithdrawals.length === 0 ? (
              <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>暂无待审批提现</div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: '#f5f5f5' }}>
                    {['代理', '金额', '银行', '账号', '申请时间', '操作'].map(h => (
                      <th key={h} style={th}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {agentWithdrawals.map(w => (
                    <tr key={w.id} style={{ borderBottom: '1px solid #f5f5f5' }}>
                      <td style={td}>{w.agent_name}</td>
                      <td style={{ ...td, color: '#f5222d', fontWeight: 500, fontSize: 16 }}>¥{w.amount?.toLocaleString()}</td>
                      <td style={td}>{w.bank_name}</td>
                      <td style={td}>{w.bank_account}</td>
                      <td style={{ ...td, color: '#999' }}>{w.created_at}</td>
                      <td style={td}>
                        <button 
                          onClick={() => handleApproveAgentWithdrawal(w.id, true)}
                          style={{ ...btn, background: '#52c41a', color: '#fff' }}
                        >
                          批准
                        </button>
                        <button 
                          onClick={() => handleApproveAgentWithdrawal(w.id, false)}
                          style={{ ...btn, background: '#ff4d4f', color: '#fff', marginLeft: 8 }}
                        >
                          拒绝
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </>
      )}
    </div>
  )
}

const card = { background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }
const th = { padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }
const td = { padding: 12, fontSize: 13 }
const btn = { padding: '6px 12px', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }
